module.exports = __webpack_public_path__ + "img/sales_report.a10983eb.svg";